import { useState } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { Expand } from "@/libraries/design/components/expand/src/expand";
import { wacToken } from "@/libraries/design/foundations";

import {
    SideNavLink,
    SideNavLinkProps
} from "../../side-nav-link/src/side-nav-link";

export interface SideNavCollectionProps {
    type: "collection";
    collectionName: string;
    depth?: number;
    sideNavItems: (SideNavCollectionProps | SideNavLinkProps)[];
    expandParentCollection?: () => void;
}

const MAX_DEPTH = 2;

export const SideNavCollection = ({
    collectionName,
    depth = 0,
    sideNavItems,
    expandParentCollection
}: SideNavCollectionProps) => {
    const [isExpanded, setIsExpanded] = useState(false);
    if (depth >= MAX_DEPTH) return null;

    const expandParent = () => {
        if (expandParentCollection) expandParentCollection();
        setIsExpanded(true);
    };

    return (
        <li
            key={collectionName}
            css={[
                listItemCss,
                css({
                    paddingBlock:
                        depth === 0 ? token("space.200") : token("space.100")
                })
            ]}
        >
            <Expand
                label={
                    <span
                        className={depth === 0 ? "h6" : ""}
                        style={{
                            fontFamily: wacToken("font.charlie.text")
                        }}
                    >
                        {collectionName}
                    </span>
                }
                isExpanded={isExpanded}
            >
                <ul css={listStyleNoneCss}>
                    {sideNavItems.map((sideNavItem) => {
                        if (sideNavItem.type === "collection") {
                            return (
                                <SideNavCollection
                                    key={sideNavItem.collectionName}
                                    type="collection"
                                    collectionName={sideNavItem.collectionName}
                                    sideNavItems={sideNavItem.sideNavItems}
                                    depth={depth + 1}
                                    expandParentCollection={expandParent}
                                />
                            );
                        }
                        if (sideNavItem.type === "link") {
                            return (
                                <SideNavLink
                                    key={sideNavItem.text}
                                    type="link"
                                    text={sideNavItem.text}
                                    href={sideNavItem.href}
                                    depth={depth + 1}
                                    expandParentCollection={expandParent}
                                />
                            );
                        }
                        return null;
                    })}
                </ul>
            </Expand>
        </li>
    );
};

const listStyleNoneCss = css({
    listStyle: "none",
    margin: token("space.0"),
    padding: token("space.0")
});

const listItemCss = css({
    "listStyle": "none",
    "display": "flex",
    "alignItems": "center",

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> div": {
        gap: "unset"
    },

    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    "> div > button > div > p": {
        marginBlockStart: 0
    }
});
